import styles from "./ConfirmButton.module.scss";

interface IConfirmButtonProps {
  onClick: () => void;
  loading?: boolean;
  disabled?: boolean;
  title?: string;
}

export const ConfirmButton = ({
  onClick,
  loading,
  disabled,
  title,
}: IConfirmButtonProps) => {
  return (
    <button
      type="button"
      className={styles.button}
      onClick={onClick}
      disabled={disabled || loading}
      title={title}
    >
      {loading ? <span className={styles.spinner} /> : "✓"}
    </button>
  );
};
